/** @format */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { HasErrors } from '../../common/Logic/ServerResponse';
import { fetchApplicationDates } from './homeApi';
import { HomeInitialState, SetApplicationDateState } from './models';

/** API may serialize banner fields with PascalCase in some environments. */
function normalizeApplicationDatesData(data: unknown): unknown {
  if (data == null || typeof data !== 'object') return data;
  const d = data as Record<string, unknown>;
  return {
    ...d,
    homeBannerImageUrl: d.homeBannerImageUrl ?? d.HomeBannerImageUrl,
    homeBannerSignedImageUrl:
      d.homeBannerSignedImageUrl ?? d.HomeBannerSignedImageUrl,
  };
}

const initialState: HomeInitialState = {
  applicationDatesState: {} as SetApplicationDateState,
};

export const fetchApplicationDatesThunk = createAsyncThunk(
  'fetchApplicationDates',
  async () => {
    let response: any;
    await fetchApplicationDates()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationDatesThunk.pending, (state) => {
        state.applicationDatesState.status = 'loading';
      })
      .addCase(fetchApplicationDatesThunk.fulfilled, (state, action) => {
        const hasErrors = HasErrors(action);
        if (hasErrors === 1) {
          state.applicationDatesState.status = 'failed';
          state.applicationDatesState.error = action.payload;
        } else if (hasErrors === 3 || hasErrors === 2) {
          const p = action.payload ?? {};
          const rawData = p.data ?? p.Data;
          state.applicationDatesState.applicationDates =
            normalizeApplicationDatesData(rawData) as any;
          state.applicationDatesState.status = 'idle';
        }
      })
      .addCase(fetchApplicationDatesThunk.rejected, (state, action) => {
        state.applicationDatesState.status = 'failed';
        state.applicationDatesState.error = action.payload;
      });
  },
});

export const {} = homeSlice.actions;
export const selectHome = (state: RootState) => state.home;
export default homeSlice.reducer;
